var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74379 0.584133C8.28275 4.35394 6.22684 6.72342 5.13152 7.43693C4.26259 11.1205 5.5944 13.8586 6.36891 14.7671H12.0059C13.4468 14.8164 13.6054 13.4736 13.5045 12.796C14.3625 12.6358 14.247 11.333 14.082 10.7016C15.1269 10.3444 14.7649 9.14629 14.4532 8.59191L14.8794 7.43693C15.2754 5.61362 11.5247 5.69165 9.59988 5.95858C10.5238 0.895204 8.74746 0.265875 7.74379 0.584133Z",
    fill: "#0F4C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26669 14.769C2.5838 12.7568 3.58988 9.17965 4.42828 7.64258H0.65408C-0.352002 8.64866 0.514346 12.8127 1.07328 14.769H5.26669Z",
    fill: "#0F4C86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmHand);
export default __webpack_public_path__ + "static/media/confirmHand.969b38f13cfe00591e4e42661a656f6b.svg";
export { ForwardRef as ReactComponent };